import React from "react";

import { Home as StyledHome } from "./Home.styles.js";

import Loading from "../../components/Loading";
import Modal from "../../components/Modal";

import { formatPhone } from '../../utils/formatter.js';

function Home({
	document,
	setAcceptedTerms,
	acceptedTerms,
	submit,
	isOpen,
	modalLoading,
	content,
	title,
	closeModal,
	openTerms,
	openPrivacy
}) {

	if (!document) {
		return <Loading />
	}

	const FooterContent = () => (
		<StyledHome.Footer>
			<StyledHome.Footer.AcceptedTerm>
				<div className="doca-toggle__container">
					<div className="doca-toggle__input-container">
						<input
							className="doca-toggle"
							id="terms"
							type="checkbox"
							checked={acceptedTerms}
							onChange={() => setAcceptedTerms(value => !value)}
						/>

						<label
							className="doca-toggle__switch"
							htmlFor="terms"
						/>
					</div>
				</div>

				<StyledHome.Footer.AcceptedTerm.Content>
					<StyledHome.Footer.AcceptedTerm.Label htmlFor="terms">
						Declaro que li e concordo com
					</StyledHome.Footer.AcceptedTerm.Label>
					<StyledHome.Footer.AcceptedTerm.Link as="span" onClick={openTerms}>
						Termos de uso
					</StyledHome.Footer.AcceptedTerm.Link>
					<StyledHome.Footer.AcceptedTerm.Separator>
						e
					</StyledHome.Footer.AcceptedTerm.Separator>
					<StyledHome.Footer.AcceptedTerm.Link as="span" onClick={openPrivacy}>
						Política de Privacidade
					</StyledHome.Footer.AcceptedTerm.Link>
				</StyledHome.Footer.AcceptedTerm.Content>
			</StyledHome.Footer.AcceptedTerm>

			<div className="doca flex justify-end items-center gap-4 doca-mt-4">
				<button className="doca-button doca-button--primary" disabled={!acceptedTerms} onClick={submit}>
					Visualizar para assinar
				</button>
			</div>
		</StyledHome.Footer>
	);

	return (
			<StyledHome className="doca">
				<StyledHome.Container className="doca-flex doca-flex-col doca-w-full doca-p-8">
					<StyledHome.Title className="doca-mb-2">
						Olá, {document?.destinatary?.name}
					</StyledHome.Title>

					<StyledHome.Subtitle>
						Você recebeu o documento: <strong>{document?.title}.pdf</strong> para assinar do remetente:
					</StyledHome.Subtitle>


					<StyledHome.Card className="doca-flex doca-flex-col doca-w-full doca-p-4 doca-mt-4">
						<div className="doca-flex doca-flex-col">
							<div>
								<StyledHome.Card.CompanyName>{document?.company?.name}</StyledHome.Card.CompanyName>

								<div className="doca-mt-2">
									{document?.company?.contact_email && (<StyledHome.Card.CompanyContact>{document?.company?.contact_email}</StyledHome.Card.CompanyContact>)}

									<StyledHome.Card.CompanyContact>{formatPhone(document?.company?.contact_phone) || '-'}</StyledHome.Card.CompanyContact>
								</div>
							</div>
						</div>
					</StyledHome.Card>

					<StyledHome.DesktopFooter>
						<FooterContent />
					</StyledHome.DesktopFooter>
				</StyledHome.Container>

				<StyledHome.FooterContainer>
					<FooterContent />
				</StyledHome.FooterContainer>

				<Modal
					isOpen={isOpen}
					onClose={closeModal}
					title={title}
					content={content}
					loading={modalLoading}
				/>
			</StyledHome>
	);
}

export default Home;
